import { Text } from '@chakra-ui/react';

import { AccommodationArrangedStatusEnum, AccommodationTypeStatusEnum } from 'types';

import { IAccommodationStatus } from '../../../../../../../types';

interface IProps {
  status: IAccommodationStatus;
}
export const IntroWrapper = ({ status }: IProps) => {
  const accommodationArrangedStatus = status.arrangedStatus || AccommodationArrangedStatusEnum.NONE;
  const accommodationTypeStatus = status.typeStatus || AccommodationTypeStatusEnum.NONE;

  if (
    accommodationArrangedStatus === AccommodationArrangedStatusEnum.NONE ||
    accommodationTypeStatus === AccommodationTypeStatusEnum.NONE
  ) {
    return (
      <Text>
        You have not entered a accommodation status. Once you enter your status you will be able to return and update it
        if it changes.
      </Text>
    );
  }

  const isArranged = accommodationArrangedStatus === AccommodationArrangedStatusEnum.ARRANGED;

  const arrangedText = isArranged ? 'have arranged ' : 'are yet to arrange your accommodation';

  const consideringText =
    !isArranged && accommodationTypeStatus !== AccommodationTypeStatusEnum.I_DONT_KNOW ? ' and are considering ' : '';

  let accommodationStatusText = '';

  switch (accommodationTypeStatus) {
    case AccommodationTypeStatusEnum.UNIVERSITY_ACCOMMODATION: {
      accommodationStatusText = 'university accommodation';
      break;
    }
    case AccommodationTypeStatusEnum.PRIVATE_STUDENT_ACCOMMODATION: {
      accommodationStatusText = 'private student accommodation';
      break;
    }
    case AccommodationTypeStatusEnum.PRIVATE_RENTAL: {
      accommodationStatusText = 'a private rental';
      break;
    }
    case AccommodationTypeStatusEnum.STAYING_WITH_FAMILY: {
      accommodationStatusText = 'to stay with family';
      break;
    }
    case AccommodationTypeStatusEnum.HOMESTAY: {
      accommodationStatusText = 'homestay';
      break;
    }
    case AccommodationTypeStatusEnum.OTHER: {
      accommodationStatusText = 'other accommodation';
      break;
    }
    case AccommodationTypeStatusEnum.I_DONT_KNOW: {
      accommodationStatusText = '';
      break;
    }
    default: {
      accommodationStatusText = '';
    }
  }
  return (
    <>
      <Text>
        You have told us {arrangedText}
        {consideringText}
        {accommodationStatusText}. If it is correct you do not have to do anything on this page.
      </Text>

      <Text>If your accommodation situation has changed, please let us know by completing this page.</Text>
    </>
  );
};
